import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-new-theme-info-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './new-theme-info-popup.component.html',
  styleUrl: './new-theme-info-popup.component.scss'
})
export class NewThemeInfoPopupComponent {

}
